const systemRouter = {
  path: '/masterData',
  component: () => import('@/components/home.vue'),
  children: [
    {
      path: 'cooperation',
      name: 'cooperation',
      component: () => import('@/pages/masterData/cooperation/cooperation.vue'),
      meta: {
        keepAlive: true,
        title: '合作伙伴主数据',
      },
    },
    // {
    //   path: 'cooperationMaintain',
    //   name: 'cooperationMaintain',
    //   component: ()=>import('@/pages/masterData/cooperation/cooperationMaintain.vue'),
    //   meta: {
    //     keepAlive: true,
    //     title: '合作伙伴主数据维护'
    //   }
    // },
    {
      path: 'addCooperation',
      name: 'addCooperation',
      component: () => import('@/pages/masterData/cooperation/addCooperation.vue'),
      meta: {
        keepAlive: true,
        title: '新建合作伙伴',
      },
    },
    {
      path: 'editCooperation',
      name: 'editCooperation',
      component: () => import('@/pages/masterData/cooperation/editCooperation.vue'),
      meta: {
        keepAlive: true,
        title: '合作伙伴详情',
      },
    },
    {
      path: 'approveCooperation',
      name: 'approveCooperation',
      component: () => import('@/pages/masterData/cooperation/approveCooperation.vue'),
      meta: {
        keepAlive: true,
        title: '合作伙伴主数据审批',
      },
    },
    {
      path: 'supplyChain',
      name: 'supplyChain',
      component: () => import('@/pages/masterData/supplyChain/supplyChain.vue'),
      meta: {
        keepAlive: true,
        title: '供应链主数据',
      },
    },
    {
      path: 'addSupplyChain',
      name: 'addSupplyChain',
      component: () => import('@/pages/masterData/supplyChain/addSupplyChain.vue'),
      meta: {
        keepAlive: true,
        title: '新增供应链主数据',
      },
    },
    {
      path: 'editSupplyChain',
      name: 'editSupplyChain',
      component: () => import('@/pages/masterData/supplyChain/editSupplyChain.vue'),
      meta: {
        keepAlive: true,
        title: '修改供应链主数据',
      },
    },
    {
      path: 'outsidePrice',
      name: 'outsidePrice',
      component: () => import('@/pages/masterData/outsidePrice/outsidePrice.vue'),
      meta: {
        keepAlive: true,
        title: '外部价格主数据',
      },
    },
    {
      path: 'addoutsidePrice',
      name: 'addoutsidePrice',
      component: () => import('@/pages/masterData/outsidePrice/addOutsidePrice.vue'),
      meta: {
        keepAlive: true,
        title: '外部价格主数据新增',
      },
    },
    {
      path: 'editOutsidePrice',
      name: 'editOutsidePrice',
      component: () => import('@/pages/masterData/outsidePrice/editOutsidePrice.vue'),
      meta: {
        keepAlive: true,
        title: '外部价格主数据修改',
      },
    },
    {
      path: 'bank',
      name: 'bank',
      component: () => import('@/pages/masterData/bank/bank.vue'),
      meta: {
        keepAlive: true,
        title: '银行主数据',
      },
    },
    {
      path: 'personnel',
      name: 'personnel',
      component: () => import('@/pages/masterData/personnel/personnel.vue'),
      meta: {
        keepAlive: true,
        title: '人员主数据',
      },
    },
    {
      path: 'addpersonnel',
      name: 'addpersonnel',
      component: () => import('@/pages/masterData/personnel/addpersonnel.vue'),
      meta: {
        keepAlive: true,
        title: '新建人员主数据',
      },
    },
    {
      path: 'viewPersonnel',
      name: 'viewPersonnel',
      component: () => import('@/pages/masterData/personnel/viewPersonnel.vue'),
      meta: {
        keepAlive: true,
        title: '查看人员主数据',
      },
    },
    {
      path: 'editPersonnel',
      name: 'editPersonnel',
      component: () => import('@/pages/masterData/personnel/editPersonnel.vue'),
      meta: {
        keepAlive: true,
        title: '修改人员主数据',
      },
    },
    {
      path: 'toExaminePersonnel',
      name: 'toExaminePersonnel',
      component: () => import('@/pages/masterData/personnel/toExaminePersonnel.vue'),
      meta: {
        keepAlive: true,
        title: '审核人员主数据',
      },
    },
    {
      path: 'goods',
      name: 'goods',
      component: () => import('@/pages/masterData/goods/goods.vue'),
      meta: {
        keepAlive: true,
        title: '商品主数据',
      },
    },
    {
      path: 'goodsDetail',
      name: 'goodsDetail',
      component: () => import('@/pages/masterData/goods/goodsDetail.vue'),
      meta: {
        keepAlive: true,
        title: '商品主数据详情',
      },
    },
    {
      path: 'addGoods',
      name: 'addGoods',
      component: () => import('@/pages/masterData/goods/addGoods.vue'),
      meta: {
        keepAlive: true,
        title: '新建商品主数据',
      },
    },
    {
      path: 'addDetailGoods',
      name: 'addDetailGoods',
      component: () => import('@/pages/masterData/goods/editGoods.vue'),
      meta: {
        keepAlive: true,
        title: '新建详细商品主数据',
      },
    },
    {
      path: 'editGoods',
      name: 'editGoods',
      component: () => import('@/pages/masterData/goods/editGoods.vue'),
      meta: {
        keepAlive: true,
        title: '修改商品主数据',
      },
    },
    {
      path: 'goodsChild',
      name: 'goodsChild',
      component: () => import('@/pages/masterData/goodsChild/list.vue'),
      meta: {
        keepAlive: true,
        title: '商品子类数据维护',
      },
    },
    {
      path: 'approveGoods',
      name: 'approveGoods',
      component: () => import('@/pages/masterData/goods/approveGoods.vue'),
      meta: {
        keepAlive: true,
        title: '修改商品主数据审批',
      },
    },
    {
      path: 'forbidenGoods',
      name: 'forbidenGoods',
      component: () => import('@/pages/masterData/goods/forbidenGoods.vue'),
      meta: {
        keepAlive: true,
        title: '商品主数据禁用',
      },
    },
    {
      path: 'company',
      name: 'company',
      component: () => import('@/pages/masterData/organization/company/company.vue'),
      meta: {
        keepAlive: true,
        title: '公司维护',
      },
    },
    {
      path: 'department',
      name: 'department',
      component: () => import('@/pages/masterData/organization/department/department.vue'),
      meta: {
        keepAlive: true,
        title: '部门维护',
      },
    },
    {
      path: 'organizationQuery',
      name: 'organizationQuery',
      component: () => import('@/pages/masterData/organization/organizationQuery/index.vue'),
      meta: {
        keepAlive: true,
        title: '组织主数据查询',
      },
    },
    {
      path: 'controlRange',
      name: 'controlRange',
      component: () => import('@/pages/masterData/organization/controlRange/controlRange.vue'),
      meta: {
        keepAlive: true,
        title: '控制范围维护',
      },
    },
    {
      path: 'instersetGroup',
      name: 'instersetGroup',
      component: () => import('@/pages/masterData/organization/interestGroup/interestGroup.vue'),
      meta: {
        keepAlive: true,
        title: '部门组',
      },
    },
    {
      path: 'warehouse',
      name: 'warehouse',
      component: () => import('@/pages/masterData/organization/warehouse/warehouse.vue'),
      meta: {
        keepAlive: true,
        title: '仓库维护',
      },
    },
    {
      path: 'addWarehouse',
      name: 'addWarehouse',
      component: () =>
        import('@/pages/masterData/organization/components/addModal/addWarehouse.vue'),
      meta: {
        keepAlive: true,
        title: '仓库创建',
      },
    },
    {
      path: 'warehouseDetail',
      name: 'warehouseDetail',
      component: () =>
        import('@/pages/masterData/organization/components/detail/warehouseDetail.vue'),
      meta: {
        keepAlive: true,
        title: '仓库详情',
      },
    },
    {
      path: 'editWarehouse',
      name: 'editWarehouse',
      component: () => import('@/pages/masterData/organization/components/edit/editWarehouse.vue'),
      meta: {
        keepAlive: true,
        title: '仓库修改',
      },
    },
    {
      path: 'financeAccount',
      name: 'financeAccount',
      component: () => import('@/pages/masterData/account/list.vue'),
      meta: {
        keepAlive: true,
        title: '财务科目主数据维护',
      },
    },
    {
      path: 'financeAccountAdd',
      name: 'financeAccountAdd',
      component: () => import('@/pages/masterData/account/add.vue'),
      meta: {
        keepAlive: true,
        title: '财务科目主数据新增',
      },
    },
    {
      path: 'financeAccountEdit',
      name: 'financeAccountEdit',
      component: () => import('@/pages/masterData/account/edit.vue'),
      meta: {
        keepAlive: true,
        title: '财务科目主数据修改',
      },
    },
    {
      path: 'financeAccountDetail',
      name: 'financeAccountDetail',
      component: () => import('@/pages/masterData/account/details.vue'),
      meta: {
        keepAlive: true,
        title: '财务科目主数据详情',
      },
    },
    {
      path: 'mdg',
      name: 'mdg',
      component: () => import('@/pages/masterData/mdg/list.vue'),
      meta: {
        keepAlive: true,
        title: 'MDG推送记录',
      },
    },
    {
      path: 'service',
      name: 'service',
      component: () => import('@/pages/intermodality/service/service.vue'),
      meta: {
        keepAlive: true,
        title: '服务主数据',
      },
    },
    {
      path: 'haulingTrack',
      name: 'haulingTrack',
      component: () => import('@/pages/intermodality/haulingTrack/index.vue'),
      meta: {
        keepAlive: true,
        title: '运输线路主数据',
      },
    },
    {
      path: 'goodsMaintain',
      name: 'goodsMaintain',
      component: () => import('@/pages/masterData/goodsMaintain/index.vue'),
      meta: {
        keepAlive: true,
        title: '商品属性维护',
      },
    },
    {
      path: 'paymentHistory',
      name: 'paymentHistory',
      component: () => import('@/pages/masterData/paymentHistory/index.vue'),
      meta: {
        keepAlive: true,
        title: '投送人历史付款记录',
      },
    },
  ],
};
export default systemRouter;
